export const Grouping = {
	fcje: { value: 'fcje', label: 'Group > Client Name > Job > Employee' },
	fjcj: { value: 'fjcj', label: 'Group > Job Category > Client Name > Job' },
} as const

export type Grouping = (typeof Grouping)[keyof typeof Grouping]
